import { ApiHost } from "@/constants";
import { request } from "@umijs/max";

const DEVICE_SERVICE_BASE_URL = `${ApiHost}/device-service`;

export async function queryProjectList() {
  return request<any>("/web/v1/device/pool/list", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
  });
}

/** 设备/安全侧栏切换：返回 id + 空间/场馆/泳池名称 */
export type IotPoolSwitcherItem = {
  id?: number | string;
  poolName?: string;
  gymId?: number | string;
  gymName?: string;
  spaceId?: number | string;
  spaceName?: string;
  /** 该泳池启用中的安全摄像机数量 */
  cameraCount?: number;
};

export async function queryPoolSwitcherList() {
  return request<{
    code?: number;
    msg?: string;
    data?: IotPoolSwitcherItem[];
  }>("/web/v1/device/pool/switcher-list", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
  });
}

export async function queryProjectPage(body: Record<string, any>) {
  return request<any>("/web/v1/device/pool/page", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    data: body,
  });
}

export async function addProjectInfo(body: Record<string, any>) {
  return request<any>("/web/v1/device/pool/add", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    data: body,
  });
}

export async function updateProjectInfo(
  body: Record<string, any>,
  params: { poolId: number | string }
) {
  return request<any>("/web/v1/device/pool/update", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    params,
    data: body,
  });
}

export async function updateProjectSelfInfo(
  body: Record<string, any>,
  params: { poolId: number | string }
) {
  return request<any>("/web/v1/device/pool/self/update", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    params,
    data: body,
  });
}

export async function deleteProjectInfo(params: { poolId: number | string }) {
  return request<any>("/web/v1/device/pool/delete", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
    params,
  });
}

export async function queryProjectMembers(params: { poolId: number | string }) {
  return request<any>("/web/v1/device/pool/member/list", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
    params,
  });
}

export async function searchProjectStaff(params: {
  poolId: number | string;
  keyword?: string;
}) {
  return request<any>("/web/v1/device/pool/member/staff/search", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
    params,
  });
}

export async function saveProjectMember(
  body: Record<string, any>,
  params: { poolId: number | string }
) {
  return request<any>("/web/v1/device/pool/member/save", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    params,
    data: body,
  });
}

export async function deleteProjectMember(params: {
  poolId: number | string;
  /** 成员主键可能为雪花 Long，用字符串避免精度丢失 */
  memberId: string | number;
}) {
  return request<any>("/web/v1/device/pool/member/delete", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "GET",
    params,
  });
}

export async function setProjectMemberExternalStream(params: {
  poolId: number | string;
  staffId: number | string;
  enabled: boolean;
}) {
  return request<any>("/web/v1/device/pool/member/external-stream", {
    baseURL: DEVICE_SERVICE_BASE_URL,
    method: "POST",
    params,
  });
}
